export var __assetsname = "./assets";
export var __cdnname = "./cdn";
export var __imagesname = "".concat(__assetsname, "/images");
export var __atlasname = "".concat(__assetsname, "/atlas");
export var __audioname = "".concat(__assetsname, "/audio");
export var __uiname = "".concat(__imagesname, "/ui");
export var __uigameplayname = "".concat(__imagesname, "/ui/home-and-gameplay");
export var __charactername = "".concat(__imagesname, "/Characters");
export var __weaponname = "".concat(__imagesname, "/Weapons");
export var __objectname = "".concat(__imagesname, "/Objects");
export var __profilename = "".concat(__imagesname, "/profile");
